import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import { CheckCircle2, Clock, Upload, History } from "lucide-react";
import { fmtDataHora } from "./constants";

const iconFor = (tipo) => {
  if (tipo === "criacao") return <CheckCircle2 className="w-4 h-4 text-blue-600" />;
  if (tipo === "status") return <Clock className="w-4 h-4 text-purple-600" />;
  if (tipo === "documento") return <Upload className="w-4 h-4 text-green-600" />;
  return <History className="w-4 h-4 text-slate-500" />;
};

export function TimelineInscricao({ inscricaoId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/inscricoes/${inscricaoId}/timeline`)
      .then((r) => { if (active) setData(r.data); })
      .catch((e) => { logger.error("Falha ao carregar timeline", e); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [inscricaoId]);

  if (loading) return <div className="text-xs text-slate-400 italic p-2">Carregando histórico...</div>;
  if (!data?.events?.length) {
    return <div className="text-xs text-slate-400 italic p-2">Sem eventos registrados ainda.</div>;
  }

  return (
    <ol className="relative border-l-2 border-slate-200 ml-2 space-y-3" data-testid={`cidadao-timeline-${inscricaoId}`}>
      {data.events.map((ev, idx) => (
        <li key={`${ev.tipo}-${ev.data}-${idx}`} className="ml-3 pl-2" data-testid={`timeline-event-${idx}`}>
          <span className="absolute -left-[9px] w-4 h-4 bg-white rounded-full flex items-center justify-center ring-2 ring-slate-200">
            {iconFor(ev.tipo)}
          </span>
          <div className="text-xs text-slate-400 font-medium">{fmtDataHora(ev.data)}</div>
          <div className="text-sm font-semibold text-slate-800">{ev.titulo}</div>
          {ev.descricao && <div className="text-xs text-slate-600 mt-0.5">{ev.descricao}</div>}
        </li>
      ))}
    </ol>
  );
}
